<template>
  <div class="recommend-items-base">
    <h4><img src="/static/img/yearluck/y2020/titlelabel/recommend.svg"></h4>
    <template v-for="(item, index) in itemList">
      <recommend-card
        :key="index"
        :tgt-item="item"
      ></recommend-card>
    </template>
  </div>
</template>

<script>
import RecommendCard from "@/utvStore/components/YearLuck/y2020/partials/recommendCard";

export default {
  name: "recommendItems",
  components: { RecommendCard },
  props: {
    itemList: {
      type: Array,
      default() {
        return []
      }
    }
  }
}</script>

<style scoped lang="scss">
  .recommend-items-base {
    width: 100%;
    h4 {
      width: 100%;
      img {
        display: block;
        margin: auto;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2020/partials/recommendItems.vue